const { trackingParams } = require('./tracking-params')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {object} tracking
 * @returns {*}
 */
function parseTracking (tracking = {}) {
  for (const [key, value] of Object.entries(tracking)) {
    const item = trackingParams[key]

    if (value && item?.type === 'int') {
      tracking[key] = parseInt(value, 10)
    } else if (value && item?.type === 'string') {
      tracking[key] = value.toString()
    }
  }

  return tracking
}

module.exports = { parseTracking }
